import React from "react"

import initView          from '../../display/views/initView'
import VeterinariansList from '../../display/lists/VeterinariansList'
import View              from '../../display/views/View'

const styles = () => ({}) ;

class Veterinarians extends View
{
    build = () =>
    (
        <div className='flex flex-col w-full'>
            <VeterinariansList parent = { this.element } />
        </div>
    );

    getLocale = () => this.props.locale.views.veterinarians ;
}

Veterinarians.defaultProps =
{
    ...View.defaultProps
};

Veterinarians.propTypes =
{
    ...View.propTypes
};

export default initView( Veterinarians, styles );
